import { RateLimitError, invokeTutor } from "./solve";

export async function generatePractice(concept: string, exampleQuestion: string, outputLanguage = "en"): Promise<string> {
  const { data, error } = await invokeTutor({ action: "practice", concept, exampleQuestion, outputLanguage });

  if (error) {
    const ctx = (error as { context?: unknown }).context;
    if (ctx instanceof Response) {
      let body: { error?: string; retryAfterSeconds?: number } = {};
      try { body = await ctx.clone().json(); } catch { /* ignore */ }
      if (ctx.status === 429) {
        const retry = Number(ctx.headers.get("Retry-After")) || body.retryAfterSeconds || 60;
        throw new RateLimitError(body.error || "Too many practice requests. Please slow down.", retry);
      }
      if (body.error) throw new Error(body.error);
    }
    throw new Error(error instanceof Error ? error.message : "Failed to generate practice problem");
  }
  if (data?.error) throw new Error(data.error);
  return data.question;
}
